import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class RateCardLandingTour extends BaseTour {
  id = 'rate-card-landing';

  content = 'Rate Card Manager - Landing Page';

  placement: Placement = 'bottom';

  steps = {
    rateCardPage: () => ({
      content:
        'Welcome to the Rate Card Manager. This is where your contractual rates are configured so invoices can be validated against them. Content is organized as: Service Provider → Shipping Service → Validity Period → Charges.',
      placement: 'bottom' as Placement,
    }),

    accordionHeader: () => ({
      content:
        'Click the accordion header to expand and view all available service providers. Each accordion represents a different modality (Ocean, Air, etc.) with its service providers listed inside.',
      placement: 'bottom' as Placement,
    }),
  } as const;
}
